<template>
  <div class="valeria-button">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CustomButton',
}
</script>

<style scoped>
.valeria-button {
  color: white;
  display: inline-block;
  background: linear-gradient(180deg, #93267B 0%, #5B0042 100%);
  border: 3px solid #FFFFFF;
  box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.36), inset 0px 0px 10px #000000;
  border-radius: 20px;
  font-family: 'Piedra';
  font-size: 33px;
  line-height: 76.5%;
  text-align: center;
  text-transform: uppercase;
  user-select: none;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}

.valeria-button:active {
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5), inset 0px 0px 20px #000000;
}

.valeria-button a {
  color: white;
  text-decoration: none;
  display: inline-block;
  padding: 40px 70px;
}

@media(max-width: 500px) {
    .valeria-button {
      font-size: 24px;
    }
    .valeria-button a {
      padding: 40px;
    }
 }
</style>
